import { LcPhoneService } from "../../../../../services/LCPhoneService";


const putTwilioData = async function ({ commit, dispatch, state }, config) {
    const { locationId, payload } = config
    try {
        const data = await LcPhoneService.putTwilioData(locationId, payload);
        return data;
    } catch (error) {
        throw error;
    }
};

export default putTwilioData;
